namespace RioERP.Masters {
    export interface DtdcApiDetailsRow {
        Id?: number;
        AccessToken?: string;
        Cookie?: string;
        CustomerCode?: string;
        ServiceTypeId?: string;
        Name?: string;
        Address1?: string;
        Address2?: string;
        City?: string;
        State?: string;
        Pincode?: string;
        Phone?: string;
        ApiKey?: string;
        IsActive?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace DtdcApiDetailsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'AccessToken';
        export const localTextPrefix = 'Masters.DtdcApiDetails';
        export const deletePermission = 'Masters:MastersManagement:Modify';
        export const insertPermission = 'Masters:MastersManagement:Modify';
        export const readPermission = 'Masters:MastersManagement:View';
        export const updatePermission = 'Masters:MastersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            AccessToken = "AccessToken",
            Cookie = "Cookie",
            CustomerCode = "CustomerCode",
            ServiceTypeId = "ServiceTypeId",
            Name = "Name",
            Address1 = "Address1",
            Address2 = "Address2",
            City = "City",
            State = "State",
            Pincode = "Pincode",
            Phone = "Phone",
            ApiKey = "ApiKey",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
